module.exports = __webpack_public_path__ + "media/images/prevention_form/koerperbild-59b2d0dfb94792c1ab14194c72c4b045.svg";